var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.414,
    height: 75,
    viewBox: "0 0 70.414 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "benefit",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M68.262,276.807a7.209,7.209,0,0,0-9.942,0l-9.249,9.255H45.293a7.031,7.031,0,0,0-6.4-9.375l-12.705-2.309a2.294,2.294,0,0,0-.41-.035H16.406A2.344,2.344,0,0,0,14.063,272H2.344A2.344,2.344,0,0,0,0,274.344v30.469a2.344,2.344,0,0,0,2.344,2.344H50.977v-2.344l.084,2.344a6.2,6.2,0,0,0,4.791-2.431L68.761,286.89A7.668,7.668,0,0,0,68.262,276.807Zm-63.574-.12h7.031v25.781H4.688Zm60.363,7.333L52.144,301.855a1.457,1.457,0,0,1-1.088.609l-.138,0H16.406V279.031h9.162l12.685,2.3a2.293,2.293,0,0,0,.419.04,2.344,2.344,0,0,1,0,4.688H27.1a2.344,2.344,0,0,0,0,4.688H50.042a2.344,2.344,0,0,0,1.657-.687l9.944-9.942a2.411,2.411,0,0,1,3.314,0A2.992,2.992,0,0,1,65.051,284.021Zm0,0",
    transform: "translate(0 -232.156)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M272.8,100.109A16.406,16.406,0,1,0,256.4,83.7,16.406,16.406,0,0,0,272.8,100.109Zm0-28.125A11.719,11.719,0,1,1,261.086,83.7,11.719,11.719,0,0,1,272.8,71.984Zm0,0",
    transform: "translate(-218.84 -57.439)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M334.258,127.016a1.172,1.172,0,0,1,0,2.344h-1.319a2.344,2.344,0,1,0,0,4.688h1.319a5.859,5.859,0,0,0,0-11.719,1.172,1.172,0,0,1,0-2.344h1.32a2.344,2.344,0,0,0,0-4.688h-1.32a5.859,5.859,0,0,0,0,11.719Zm0,0",
    transform: "translate(-280.293 -98.408)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M48.8,32.813A16.406,16.406,0,1,0,32.4,16.406,16.406,16.406,0,0,0,48.8,32.813Zm0-28.125A11.719,11.719,0,1,1,37.086,16.406,11.719,11.719,0,0,1,48.8,4.688Zm0,0",
    transform: "translate(-27.652 0)",
    fill: "#f4805a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M110.258,59.719a1.172,1.172,0,0,1,0,2.344h-1.32a2.344,2.344,0,1,0,0,4.688h1.32a5.859,5.859,0,0,0,0-11.719,1.172,1.172,0,1,1,0-2.344h1.319a2.344,2.344,0,1,0,0-4.688h-1.319a5.859,5.859,0,1,0,0,11.719Zm0,0",
    transform: "translate(-89.105 -40.969)",
    fill: "#f4805a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3);
export default __webpack_public_path__ + "static/media/W3.2a6e7504ab476071638ee5021914989f.svg";
export { ForwardRef as ReactComponent };